import * as React from "react";
import { observer } from "mobx-react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Pager } from "../utils/Pager";
import { Alert, Alignment, Button, Classes, Dialog, FormGroup, H5, InputGroup, Intent, NonIdealState, Popover, TextArea } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import IntlCurrencyInput from "react-intl-currency-input";
import { converterData, formatCnpj } from "../../utils";
import { TabelaSpedSelect, filterItens, renderItens } from "../utils/TabelaSpedSelect";
import { IEmpresa, ISpedTabela } from "../../model";
import { toast } from "react-toastify";
import moment from "moment";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { AjusteSelect, renderItensAjustes, filterItensAjustes } from "../utils/AjustesSelect";
import { AjusteSpedStore } from "../../stores/admin/AjusteSpedStore";
import { SpedLancamentoStore } from "../../stores/sped/SpedLancamentoStore";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ptBR } from '@mui/x-date-pickers/locales';
import dayjs from "dayjs";

var debounce = require('lodash.debounce');

@observer
export default class LancamentosEstaduaisPage extends React.Component<{}, {}> {
  obs = observable({
    open_create_lancamento: false as boolean,

    id: null as string,
    data: "" as string,
    selecione_ajuste: null,
    valor: 0 as number,
    observacao: "" as string,
    selecione_ajuste_sped: null,

    lancamentos: [] as any,

    fetchOptions: {} as any
  })

  constructor(props: any) {
    super(props);

    this.obs.fetchOptions = debounce(this.handleBuscaLancamentos.bind(this), 800);

  }

  async componentDidMount() { }

  handleChangePage(page: number) {

    SpedLancamentoStore.obs.lancamentos_current = page

    SpedLancamentoStore.handleBuscaLancamentos(SpedLancamentoStore.obs.selectedEmpresa.cnpj, page, SpedLancamentoStore.obs.lancamentos_filter)

  }

  handleBuscaFiltered(filtro: string) {

    SpedLancamentoStore.obs.lancamentos_filter = filtro
    SpedLancamentoStore.obs.lancamentos_current = 1

    this.obs.fetchOptions()

  }

  async handleBuscaLancamentos() {

    await SpedLancamentoStore.handleBuscaLancamentos(SpedLancamentoStore.obs.selectedEmpresa.cnpj, SpedLancamentoStore.obs.lancamentos_current, SpedLancamentoStore.obs.lancamentos_filter)

  }

  handleEditLancamento(row) {

    this.obs.open_create_lancamento = true

    this.obs.id = row.id
    this.obs.data = moment(row.data).add(3, "hours").format("YYYY-MM-DD")
    this.obs.selecione_ajuste = row.ajustes_sped
    this.obs.valor = row.valor
    this.obs.observacao = row.observacao
    this.obs.selecione_ajuste_sped = row.tabelas_sped

  }

  handleCreateLancamento() {

    this.obs.open_create_lancamento = true

    this.obs.id = ""
    this.obs.data = null
    this.obs.selecione_ajuste = ""
    this.obs.valor = 0
    this.obs.observacao = ""
    this.obs.selecione_ajuste_sped = null

  }

  onClose() {

    this.obs.open_create_lancamento = false

    this.obs.id = ""
    this.obs.data = null
    this.obs.selecione_ajuste = ""
    this.obs.valor = 0
    this.obs.observacao = ""
    this.obs.selecione_ajuste_sped = null

  }

  async handleSave() {

    if (!this.obs.data) {
      toast.warning('Insira uma Data!', {});
      return;
    }

    if (!this.obs.selecione_ajuste) {
      toast.warning('Selecione um Ajuste!', {});
      return;
    }

    if (!this.obs.selecione_ajuste_sped) {
      toast.warning('Selecione um Ajuste no SPED!', {});
      return;
    }

    let params = {
      id: this.obs.id,
      data: this.obs.data,
      id_ajuste: (this.obs.selecione_ajuste.id || this.obs.selecione_ajuste._id),
      valor: this.obs.valor,
      observacao: this.obs.observacao,
      id_tabela_sped: (this.obs.selecione_ajuste_sped.id || this.obs.selecione_ajuste_sped._id),
      cnpj: SpedLancamentoStore.obs.selectedEmpresa.cnpj,
      uf: (SpedLancamentoStore.obs.selectedEmpresa.uf).toLowerCase()
    }

    if (!this.obs.id) {

      delete params.id

      await SpedLancamentoStore.handleCreateLancamentos(params)

    } else {

      await SpedLancamentoStore.handleUpdateLancamentos(params)

    }

    this.onClose()
  }

  async handleDeleteLancamento(id: string) {

    await SpedLancamentoStore.handleDeleteLancamento(id)

  }

  handleDataChange = (value) => {

    this.obs.data = value && value.$d ? moment(value.$d).startOf("month").format("YYYY-MM-DD") : ""

  }

  formaterDetalhes = (cell, row) => {
    return (
      <>
        <MDBBtn color="default" rounded size="sm" onClick={() => this.handleEditLancamento(row)}>
          <img src="/images/edit.png" width={15} />
        </MDBBtn>
        <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
          <MDBBtn color="default" rounded size="sm" >
            <img src="/images/bin.png" width="25px" />

          </MDBBtn>
          <div>
            <H5>Confirmar exclusão?</H5>
            <p style={{ fontSize: 11 }}>Tem certeza de que deseja excluir esse item? Você não será capaz de recuperá-lo.</p>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 15,
              }}
            >
              <Button
                className={Classes.POPOVER_DISMISS}
                style={{ marginRight: 10 }}
              >
                Cancelar
              </Button>
              <Button
                intent="danger"
                className={Classes.POPOVER_DISMISS}
                onClick={() => this.handleDeleteLancamento(row.id)}
              >
                Excluir
              </Button>
            </div>
          </div>
        </Popover>
      </>
    )
  }

  formaterAjuste = (cell, row) => {

    if (!cell) return ""

    return `${cell.nome}`
  }

  formaterAjusteSped = (cell, row) => {

    if (!cell) return ""

    return `${cell.codigo} - ${cell.descricao}`
  }

  formaterDate = (cell, row) => {

    return moment(cell).add(3, "hours").format("MM/YYYY");

  };

  isRegistroValido = (registro: ISpedTabela): boolean => {

    const dataAtual = new Date();
    const dataInicio = converterData(registro.data_inicio);
    const dataFim = converterData(registro.data_fim);

    if (!dataInicio) return false;

    const validoAposInicio = dataAtual >= dataInicio;

    const validoAntesFim = !dataFim || dataAtual <= dataFim;

    return validoAposInicio && validoAntesFim;
  }

  async handleLoadSpedEfd() {

    if (SpedLancamentoStore.obs.selectedEmpresa.cnpj == "") {
      toast.warning('Você precisa selecionar uma empresa para filtrar.', {});
      return
    }

    SpedLancamentoStore.obs.lancamentos_current = 1
    SpedLancamentoStore.obs.lancamentos_filter = ""

    await SpedLancamentoStore.handleBuscaLancamentos(SpedLancamentoStore.obs.selectedEmpresa.cnpj, 1, "")

    await AjusteSpedStore.ajustes_all(SpedLancamentoStore.obs.selectedEmpresa.uf)

    SpedLancamentoStore.obs.isEmpresa = true
    SpedLancamentoStore.obs.open_select_empresa = false
  }

  formatDate(date) {

    return dayjs(date)

  }

  render() {

    let empresaTextProg = SpedLancamentoStore.obs.selectedEmpresa.cnpj != ""
      ? `${SpedLancamentoStore.obs.selectedEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(SpedLancamentoStore.obs.selectedEmpresa.cnpj)})`
      : "Selecione uma empresa";

    let titleEmpresaText = SpedLancamentoStore.obs.selectedEmpresa.cnpj != ""
      ? SpedLancamentoStore.obs.selectedEmpresa.razao_social + " - (" + formatCnpj(SpedLancamentoStore.obs.selectedEmpresa.cnpj) + ")"
      : "";

    return (<>

      <MDBCol>
        <MDBRow>
          <MDBBtn className="btnDefault btnBuscarNfe" onClick={() => SpedLancamentoStore.obs.open_select_empresa = true}>Selecionar Empresa</MDBBtn>
          <h2 className="titleSEFAZ titleEmpresaSped">{titleEmpresaText}</h2>
        </MDBRow>
      </MDBCol>

      {!SpedLancamentoStore.obs.isEmpresa
        ? this.renderBlock()
        : this.renderLancamentos()
      }

      <Alert
        cancelButtonText="Fechar"
        confirmButtonText="Carregar"
        isOpen={SpedLancamentoStore.obs.open_select_empresa}
        onClose={() => SpedLancamentoStore.obs.open_select_empresa = false}
        onConfirm={() => this.handleLoadSpedEfd()}
        className="AlertUser"
        canOutsideClickCancel={true}
        intent={Intent.PRIMARY}
      >
        <h2 className="titleSEFAZ">Selecione uma Empresa</h2>
        <FormGroup
          className="empresaSelect"
        >
          <EmpresaSelect
            items={EmpresaStore.sortedEmpresas}
            itemRenderer={renderEmpresa}
            itemPredicate={filterEmpresa}
            onItemSelect={(e: IEmpresa) => SpedLancamentoStore.obs.selectedEmpresa = e}
            inputProps={{ placeholder: "Filtrar uma empresa" }}
          >
            <Button
              text={empresaTextProg}
              rightIcon="double-caret-vertical"
              alignText={Alignment.LEFT}
            />
          </EmpresaSelect>
        </FormGroup>
      </Alert>
    </>)

  }

  renderBlock() {
    return (
      <div className="nz-non-ideal">
        <NonIdealState
          icon="box"
          description={"Selecione uma Empresa para realizar os Lançamentos Estaduais"} />
      </div>
    );
  }

  renderLancamentos() {

    const currencyConfig = {
      locale: "pt-BR",
      formats: {
        number: {
          BRL: {
            style: "decimal",
            currency: "BRL",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          },
        },
      },
    };

    let produtos = SpedLancamentoStore.obs.lancamentos?.map(obj => {
      return ({
        id: obj._id || obj.id,
        codigo: obj.codigo,
        data: obj.data,
        tabelas_sped: obj.tabelas_sped,
        valor: obj.valor,
        observacao: obj.observacao,
        ajustes_sped: obj.ajustes_sped,
      });
    })

    const hanldeRendimento = (event, value) => {
      this.obs.valor = value
    }

    let ajusteSpedText = this.obs.selecione_ajuste_sped?.descricao ? `${this.obs.selecione_ajuste_sped.codigo} - ${this.obs.selecione_ajuste_sped.descricao.substring(0, 70)}...`
      : "Selecione uma Tabela Sped";

    let ajusteText = this.obs.selecione_ajuste?.nome ? `${this.obs.selecione_ajuste.nome}`
      : "Selecione um Ajuste";

    const registrosValidos = (this.obs.selecione_ajuste?.ids_tabelas_sped || []).filter(this.isRegistroValido);

    return (
      <>

        <br />
        <br />

        <MDBRow style={{ display: "flex", width: "100%", marginBottom: "10px" }}>
          <MDBCol md="3">
            <InputGroup
              round
              leftIcon="search"
              style={{ borderRadius: 10 }}
              placeholder="Filtrar (Observação)"
              value={SpedLancamentoStore.obs.lancamentos_filter}
              onChange={(e: any) => this.handleBuscaFiltered(e.target.value)} />
          </MDBCol>

          <MDBCol md="3">
            <Button
              text="Criar Lançamento"
              className="btnDefault btnBuscarNfe btnVerde"
              onClick={() => this.handleCreateLancamento()}
            />
          </MDBCol>

        </MDBRow>

        <BootstrapTable className="TabelaSimples" data={produtos}>
          <TableHeaderColumn dataField="id" width="1%" isKey={true} hidden >#</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.formaterDate} dataField="data" width="20%">Data</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.formaterAjuste} dataField="ajustes_sped" width="20%">Ajuste</TableHeaderColumn>
          <TableHeaderColumn dataField="valor" width="20%">Valor</TableHeaderColumn>
          <TableHeaderColumn dataField="observacao" width="20%">Observação</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.formaterAjusteSped} dataField="tabelas_sped" width="50%">Ajuste no SPED</TableHeaderColumn>
          <TableHeaderColumn dataFormat={this.formaterDetalhes} width="15%"></TableHeaderColumn>
        </BootstrapTable>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={SpedLancamentoStore.obs.lancamentos_current}
            totalCount={SpedLancamentoStore.obs.lancamentos_length}
            pageSize={10}
            onPageChange={(page) => this.handleChangePage(page)}
          />
        </div>

        <Dialog
          isOpen={this.obs.open_create_lancamento}
          onClose={() => this.obs.open_create_lancamento = false}
          className="AlertUser"
        >
          <h2 className="titleSEFAZ">Outros Lançamentos</h2>

          <FormGroup label="Data" labelInfo="*">
            <LocalizationProvider
              localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
              adapterLocale={"pt-br"}
              dateAdapter={AdapterDayjs}>
              <DatePicker className="input-data-apuracao" views={['month', 'year']} onChange={(value) => this.handleDataChange(value)} value={this.formatDate(this.obs.data)} format="MM/YYYY" slotProps={{ textField: { size: 'small' } }} />
            </LocalizationProvider>
          </FormGroup>

          <FormGroup className="empresaSelect" label="Ajuste" labelInfo="*">
            <AjusteSelect
              items={AjusteSpedStore.obs.ajustes.filter(x => !x.ajuste_sistema)}
              itemRenderer={renderItensAjustes}
              itemPredicate={filterItensAjustes}
              onItemSelect={(e) => this.obs.selecione_ajuste = e}
              matchTargetWidth={true}
              inputProps={{ placeholder: "Filtrar um ajuste" }}
            >
              <Button
                text={ajusteText}
                rightIcon="double-caret-vertical"
                alignText={Alignment.LEFT}
              />
            </AjusteSelect>
          </FormGroup>

          {this.obs.selecione_ajuste && !this.obs.selecione_ajuste.presumido &&
            <FormGroup label="Valor" labelInfo="*">
              <IntlCurrencyInput
                className="form-control"
                onChange={hanldeRendimento}
                value={this.obs.valor}
                currency="BRL"
                config={currencyConfig}
              />
            </FormGroup>
          }

          <FormGroup label="Observação" labelInfo="*">
            <TextArea style={{ width: "100%" }} value={this.obs.observacao} onChange={(e) => this.obs.observacao = e.target.value} />
          </FormGroup>

          <FormGroup className="empresaSelect" label="Ajuste no SPED" labelInfo="*">
            <TabelaSpedSelect
              items={registrosValidos}
              itemRenderer={renderItens}
              itemPredicate={filterItens}
              onItemSelect={(e) => this.obs.selecione_ajuste_sped = e}
              matchTargetWidth={true}
              inputProps={{ placeholder: "Filtrar um tabela sped" }}
            >
              <Button
                text={ajusteSpedText}
                rightIcon="double-caret-vertical"
                alignText={Alignment.LEFT}
              />
            </TabelaSpedSelect>
          </FormGroup>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={() => this.onClose()} />
            <Button text="Salvar" intent="primary" onClick={() => this.handleSave()} />
          </div>

        </Dialog>

      </>
    )
  }
}